(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wsClient", [], factory);
	else if(typeof exports === 'object')
		exports["wsClient"] = factory();
	else
		root["wsClient"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var uuid = __webpack_require__(1);
	
	module.exports = function wsClient(_ref) {
	  var wsUrl = _ref.wsUrl,
	      token = _ref.token;
	
	  if (!wsUrl) {
	    throw new Error('wsUrl must be provided');
	  }
	  if (!token) {
	    throw new Error('token must be provided');
	  }
	
	  var pingInterval = 30000;
	  var connecting = void 0;
	  var ready = void 0;
	  var sessionId = void 0;
	  var ws = void 0;
	  var errorCount = 0;
	  var pingTimeoutFn = void 0;
	  var evs = [];
	  var processTimeout = void 0;
	  wsUrl = wsUrl.replace('http://', 'ws://').replace('https://', 'wss://');
	  var inNode = typeof window === 'undefined';
	  var WebSocket = inNode ? global.WebSocket : window.WebSocket;
	  if (typeof WebSocket === 'undefined') {
	    WebSocket = function WebSocket() {};
	    WebSocket.prototype.close = function () {};
	  }
	
	  var messageEventHandlers = {};
	  var presenceEventHandlers = {};
	  var infoEventHandlers = {};
	  var closeEventHandlers = { close: [] };
	  var systemEventHandlers = {
	    connected: [], ack: [], pong: [], unauthorized: [], error: []
	  };
	
	  function randomId() {
	    return uuid.v4();
	  }
	
	  function onOpen(cb) {
	    ws.onopen = function () {
	      return cb();
	    };
	  }
	
	  function attachEventHandlers() {
	    ws.onmessage = function (event) {
	      var message = JSON.parse(event.data);
	      var systemEvents = Object.keys(systemEventHandlers);
	      if (systemEvents.indexOf(message.type) !== -1) {
	        systemEventHandlers[message.type].forEach(function (handler) {
	          handler.fn(message);
	        });
	      } else if (message.type === 'message') {
	        var channel = message.channel;
	        if (messageEventHandlers[channel] && messageEventHandlers[channel][message.eventName]) {
	          messageEventHandlers[channel][message.eventName].forEach(function (handler) {
	            handler(message);
	          });
	        }
	        channel.split('/').reduce(function (prev, curr) {
	          if (messageEventHandlers[prev] && messageEventHandlers[prev][message.eventName]) {
	            messageEventHandlers[prev][message.eventName].forEach(function (handler) {
	              handler(message);
	            });
	          }
	          return prev + '/' + curr;
	        });
	      } else if (message.type === 'presence') {
	        var _channel = message.channel;
	        if (presenceEventHandlers[_channel]) {
	          presenceEventHandlers[_channel].forEach(function (handler) {
	            handler(message);
	          });
	        }
	      } else if (message.type === 'info') {
	        var _channel2 = message.data.channel;
	        if (infoEventHandlers[_channel2]) {
	          infoEventHandlers[_channel2].forEach(function (handler) {
	            handler(message);
	          });
	        }
	      } else if (message.type === 'error') {
	        if (systemEventHandlers.error) {
	          systemEventHandlers.error.forEach(function (handler) {
	            handler.fn(message);
	          });
	        }
	      }
	    };
	  }
	
	  function onAck(id, callback) {
	    systemEventHandlers.ack.push({
	      id: id, fn: function fn(msg) {
	        if (msg.id === id) {
	          callback(msg);
	        }
	      }
	    });
	  }
	
	  function offAck(id) {
	    var index = systemEventHandlers.ack.findIndex(function (item) {
	      return item.id === id;
	    });
	    if (index !== -1) {
	      systemEventHandlers.ack.splice(index, 1);
	    }
	  }
	
	  function onConnected(callback) {
	    systemEventHandlers.connected.push({ fn: function fn(msg) {
	        return callback(msg);
	      } });
	  }
	
	  function onPong(id, callback) {
	    systemEventHandlers.pong.push({
	      id: id, fn: function fn(msg) {
	        if (msg.id === id) {
	          callback(msg);
	        }
	      }
	    });
	  }
	
	  function offPong(id) {
	    var index = systemEventHandlers.pong.findIndex(function (item) {
	      return item.id === id;
	    });
	    if (index !== -1) {
	      systemEventHandlers.pong.splice(index, 1);
	    }
	  }
	
	  function connect() {
	    ready = false;
	    if (errorCount > 50 || connecting) {
	      return;
	    }
	
	    connecting = true;
	    ws = new WebSocket(wsUrl + '?token=' + token + '&sessionId=' + (sessionId || ''));
	    attachEventHandlers();
	    ws.onerror = function (error) {
	      errorCount++;
	      connecting = false;
	      if (systemEventHandlers.error) {
	        systemEventHandlers.error.forEach(function (handler) {
	          return handler.fn(error);
	        });
	      }
	      clearTimeout(pingTimeoutFn);
	      setTimeout(function () {
	        return connect();
	      }, 100 * errorCount);
	    };
	    onOpen(function () {
	      onConnected(function (msg) {
	        errorCount = 0;
	        sessionId = msg.sessionId;
	        ready = true;
	        connecting = false;
	        clearTimeout(pingTimeoutFn);
	        pingTimeoutFn = setTimeout(function () {
	          return ping();
	        }, pingInterval);
	      });
	    });
	  }
	
	  function initHandlers(channel) {
	    if (!messageEventHandlers[channel]) {
	      messageEventHandlers[channel] = {};
	    }
	    if (!presenceEventHandlers[channel]) {
	      presenceEventHandlers[channel] = [];
	    }
	    if (!infoEventHandlers[channel]) {
	      infoEventHandlers[channel] = [];
	    }
	  }
	
	  function addMessageHandler(_ref2) {
	    var channel = _ref2.channel,
	        eventName = _ref2.eventName,
	        callback = _ref2.callback;
	
	    if (!messageEventHandlers[channel][eventName]) {
	      messageEventHandlers[channel][eventName] = [];
	    }
	    messageEventHandlers[channel][eventName].push(callback);
	  }
	
	  function addPresenceHandler(_ref3) {
	    var channel = _ref3.channel,
	        callback = _ref3.callback;
	
	    presenceEventHandlers[channel].push(callback);
	  }
	
	  function addInfoHandler(_ref4) {
	    var channel = _ref4.channel,
	        callback = _ref4.callback;
	
	    infoEventHandlers[channel].push(callback);
	  }
	
	  function ping() {
	    if (ws.readyState !== ws.OPEN && ws.readyState !== ws.CONNECTING) {
	      connect();
	    }
	    if (!ready) {
	      clearTimeout(pingTimeoutFn);
	      pingTimeoutFn = setTimeout(function () {
	        return ping();
	      }, 50);
	      return;
	    }
	
	    var id = randomId();
	    ws.send(JSON.stringify({ type: 'ping', id: id }));
	    onPong(id, function () {
	      offPong(id);
	      clearTimeout(pingTimeoutFn);
	      pingTimeoutFn = setTimeout(function () {
	        return ping();
	      }, pingInterval);
	    });
	  }
	
	  function close() {
	    closeEventHandlers.close.forEach(function (handler) {
	      return handler();
	    });
	    messageEventHandlers = {};
	    presenceEventHandlers = {};
	    infoEventHandlers = {};
	    systemEventHandlers = {};
	    closeEventHandlers = {};
	    return ws.close();
	  }
	
	  function createListener(channel) {
	    initHandlers(channel);
	    return {
	      on: function on(eventName, callback) {
	        return addMessageHandler({ channel: channel, eventName: eventName, callback: callback });
	      },
	      onPresence: function onPresence(callback) {
	        return addPresenceHandler({ channel: channel, callback: callback });
	      },
	      onInfo: function onInfo(callback) {
	        return addInfoHandler({ channel: channel, callback: callback });
	      },
	      leave: function leave() {
	        queue('leave', { channel: channel });
	        delete messageEventHandlers[channel];
	        delete presenceEventHandlers[channel];
	        delete infoEventHandlers[channel];
	      },
	      emit: function emit(eventName, payload) {
	        queue('emit', { eventName: eventName, channel: channel, payload: payload });
	      },
	      // @TODO: remove once released and forum code updated not to use .destroy()
	      destroy: function destroy() {
	        queue('leave', { channel: channel });
	        delete messageEventHandlers[channel];
	        delete presenceEventHandlers[channel];
	        delete infoEventHandlers[channel];
	      }
	    };
	  }
	
	  function queue(event, payload) {
	    var ev = void 0;
	    if (event === 'join') {
	      ev = { type: 'subscribe', channel: payload.channel };
	    } else if (event === 'emit') {
	      ev = { type: 'publish', eventName: payload.eventName, channel: payload.channel, payload: payload.payload };
	    } else if (event === 'leave') {
	      ev = { type: 'unsubscribe', channel: payload.channel };
	    } else if (event === 'presence') {
	      ev = { type: 'presence', payload: payload };
	    }
	    ev.id = randomId();
	    evs.push(ev);
	    processQueue();
	    return ev.id;
	  }
	
	  function processQueue() {
	    clearTimeout(processTimeout);
	
	    if (evs.length < 1) {
	      return;
	    }
	
	    if (typeof ws.readyState === 'undefined' && typeof ws.OPEN === 'undefined') {
	      evs.splice(0, evs.length);
	      return;
	    }
	
	    if (ws.readyState !== ws.OPEN) {
	      connect();
	    }
	    if (!ready) {
	      processTimeout = setTimeout(function () {
	        return processQueue();
	      }, 50);
	      return;
	    }
	
	    var ev = evs.shift();
	
	    if (ev) {
	      ws.send(JSON.stringify(ev));
	
	      onAck(ev.id, function () {
	        offAck(ev.id);
	        processQueue();
	      });
	    }
	  }
	
	  function join(channel) {
	    queue('join', { channel: channel });
	    return createListener(channel);
	  }
	
	  function onError(callback) {
	    systemEventHandlers.error.push({ fn: callback });
	  }
	
	  function onClose(callback) {
	    closeEventHandlers.close.push(callback);
	  }
	
	  function onAuthRequired(callback) {
	    systemEventHandlers.unauthorized.push({ fn: callback });
	  }
	
	  connect();
	
	  return {
	    close: close,
	    createListener: createListener,
	    queue: queue,
	    join: join,
	    onError: onError,
	    onClose: onClose,
	    onAuthRequired: onAuthRequired,
	    onConnect: onConnected
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(2);
	var v4 = __webpack_require__(5);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(3);
	var bytesToUuid = __webpack_require__(4);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([bth[buf[i++]], bth[buf[i++]], 
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]]]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(3);
	var bytesToUuid = __webpack_require__(4);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ })
/******/ ])
});
;
//# sourceMappingURL=ws-client.es5.js.map